export const PREMIER_COLLECTION_HEADER = "Premier Collection";

export const UPDATE_CALENDAR_TEXT = "Choose Dates";
export const LIFESTYLE_COLLECTION_HEADER = "Lifestyle Collection";
export const PREMIUM_STAYS_HEADER = "Premium Stays";
